<template>
  <div class="pesquisa alinha-v">
    <div disabled class="icone-pesquisa"></div>
    <input placeholder="Pesquise aqui..." :value="inputValue" @input="onInput" />
  </div>
</template>

<script setup>
/* global defineProps, defineEmits */
import { ref, watch } from "vue";

const props = defineProps({
  modelValue: String,
  placeholder: {
    type: String,
    default: "Search...",
  },
});

const emit = defineEmits(["update:modelValue", "clear"]);

const inputValue = ref(props.modelValue);

watch(
  () => props.modelValue,
  (val) => {
    inputValue.value = val;
  }
);

function onInput(e) {
  emit("update:modelValue", e.target.value);
}
</script>
